<template>
  <div class="text-center">
    <img src="@/assets/img/logo_acceso2.svg" class="img-fluid" alt="logo ACCESO a la Educación Superior" style="height:5rem" >
    <br>
    <br>
    <b-spinner variant="primary" label="Spinning"></b-spinner>
  </div>
</template>

<script>
export default {};
</script>



// WEBPACK FOOTER //
// src/components/generales/modales/Cargando.vue